import { MutationCache, QueryClient } from '@tanstack/react-query';
import { toast } from '@/components/ui/toast';
import { isApiError } from './api/errors';

declare module '@tanstack/react-query' {
  interface Register {
    mutationMeta: {
      /** Skip the global error toast (the form shows the error itself). */
      silent?: boolean;
    };
  }
}

export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (error, _vars, _ctx, mutation) => {
      if (!mutation.meta?.silent) toast.error(error);
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 10 * 60_000,
      // Retry only what may succeed later: network drops and server errors.
      retry: (count, error) => isApiError(error) && (error.isNetwork || error.status >= 500) && count < 2,
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: false,
      // Send even when the browser thinks it is offline; a failure keeps the
      // form (and its Idempotency-Key) so the person can retry safely.
      networkMode: 'always',
    },
  },
});
